<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const setupVoiceChannel = () => {
  router.push({
    name: 'settings_inboxes_page_channel',
    params: { accountId: route.params.accountId, sub_page: 'voice' },
  });
};
</script>

<template>
  <EmptyStateLayout
    :title="t('CALLS_PAGE.SETUP.TITLE')"
    :subtitle="t('CALLS_PAGE.SETUP.BRIDGE_DESCRIPTION')"
    :show-backdrop="false"
    :action-perms="['inboxes.manage']"
  >
    <template #actions>
      <Button
        :label="t('CALLS_PAGE.SETUP.ACTION')"
        icon="i-lucide-plus"
        @click="setupVoiceChannel"
      />
    </template>
  </EmptyStateLayout>
</template>
